;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/training/feedback/:id\",\"regex\":\"^/training/feedback/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/training/session/:id\",\"regex\":\"^/training/session/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/pricing\"},{\"path\":\"/dpa\"},{\"path\":\"/privacy-policy\"},{\"path\":\"/terms-of-use\"},{\"path\":\"/auth\"},{\"path\":\"/aws/confirm\"},{\"path\":\"/aws/link\"},{\"path\":\"/training/overview\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "15.4.10";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";
import { clientConfig } from "@workspace/sentry";
import posthog from "posthog-js";

if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    defaults: "2025-11-30",
    name: "yolk-landing",
  });
}

Sentry.init(clientConfig);
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
